const getLedgerRole = fieldValues => {
  if (fieldValues?.categoryId?.value === '9') {
    return getRoleByProductType(fieldValues?.productType?.label);
  } else return getRoleByCategoryId(fieldValues?.categoryId?.value);
};

const getRoleByProductType = productType => {
  const creditCardSubstrings = ['CREDIT CARD', 'LINE OF CREDIT'];
  return creditCardSubstrings.some(substring => productType.toUpperCase().includes(substring))
    ? 'CREDIT_CARD'
    : 'BANK_ACCOUNT';
};

const getRoleByCategoryId = categoryId => {
  switch (categoryId) {
    case '1':
      return 'BANK_ACCOUNT';
    case '3':
      return 'CREDIT_CARD';
    case '5':
      return 'EQUITY_ACCOUNT';
    case '6':
      return 'STATEMENT_PROCESSING_ACCOUNT';
    case '7':
      return 'STATEMENT_PROCESSING_ACCOUNT';
    case '8':
      return 'STATEMENT_PROCESSING_ACCOUNT';
    default:
      return null;
  }
};

export default getLedgerRole;
